// Only the product question form remains; compare and share are removed.
class RosfoProductQuestion extends HTMLElement {
 connectedCallback() {
  this.addEventListener('click', this.handleClick);
  const dialog = this.querySelector('[data-question-dialog]');
  if (dialog?.dataset.openOnLoad === 'true' && !dialog.open) dialog.showModal();
 }
 disconnectedCallback() { this.removeEventListener('click', this.handleClick); }
 handleClick = event => { event.target.closest('[data-dialog-close]')?.closest('dialog')?.close(); };
}
if (!customElements.get('rosfo-product-question')) customElements.define('rosfo-product-question', RosfoProductQuestion);
